import React from "react";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { FilterItem } from "./models";
import Button from "../button/Button";
import Select, { SelectItem } from "../select/Select";
import AsyncSelect from "../select/AsyncSelect";

interface FilterFormProps {
  filters: FilterItem[];
  selectedFitlers?: Record<string, SelectItem[]>;
  updateFilters: (selectedFilters: Record<string, SelectItem[]>) => void;
  resetDisabled: boolean;
}

const FilterForm = ({
  filters,
  selectedFitlers,
  updateFilters,
  resetDisabled,
}: FilterFormProps) => {
  const { tInput } = useCustomTranslation();

  const handleAddFilter = (
    key: string,
    item: SelectItem | SelectItem[] | null,
  ) => {
    if (!item) return;

    if (Array.isArray(item)) {
      updateFilters({ ...selectedFitlers, [key]: item });
    }
  };

  return (
    <div>
      {filters
        .filter((x) => !x.hidden)
        .map((filter) => (
          <div className="mt-4" key={filter.key}>
            <div className="mb-2 px-2 text-[14px]/[16px] font-bold uppercase">
              {filter.label}
            </div>
            {filter.isAsync ? (
              <AsyncSelect
                // size="small"
                loadOptions={filter.loadOptions!}
                value={selectedFitlers?.[filter.key] ?? null}
                onChange={(value) => handleAddFilter(filter.key, value)}
                isMulti={true}
                placeholder={tInput("all_filter")}
                multivalueTagLabelKey="active_filter_count"
              />
            ) : (
              <Select
                options={filter.options}
                size="small"
                value={selectedFitlers?.[filter.key] ?? null}
                onChange={(value) => handleAddFilter(filter.key, value)}
                isMulti={true}
                placeholder={tInput("all_filter")}
                multivalueTagLabelKey="active_filter_count"
              />
            )}
          </div>
        ))}
      <Button
        label={tInput("reset_button")}
        size="small"
        onClick={() => updateFilters({})}
        disabled={resetDisabled}
        className="mt-4 w-full"
      />
    </div>
  );
};

export default FilterForm;
